import React from 'react';

import Field from '../../Field';
import SectionContainer from '../SectionContainer';

import css from './SectionCircularFuture.module.css';

const SectionCircularFuture = props => {
  const {
    sectionId,
    className,
    appearance,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const featureBlock = blocks?.[0];

  if (!featureBlock) {
    return null;
  }

  const {
    title,
    text,
    media,
    callToAction,
  } = featureBlock;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={css.root}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.inner}>

        {/* Imagen izquierda */}
        <div className={css.imageCol}>
          <Field
            data={media}
            className={css.image}
            options={fieldOptions}
          />
        </div>

        {/* Contenido derecho */}
        <div className={css.contentCol}>
          <Field
            data={title}
            className={css.title}
            options={fieldOptions}
          />

          <Field
            data={text}
            className={css.description}
            options={fieldOptions}
          />

          <Field
            data={callToAction}
            className={css.ctaButton}
            options={fieldOptions}
          />
        </div>

      </div>
    </SectionContainer>
  );
};

export default SectionCircularFuture;